import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type AuthProvidersState, type AuthProvidersActionTypes } from 'app/store/types';

const initialState: AuthProvidersState = {};

const authProvidersReducer = (state = initialState, action: AuthProvidersActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { authProviders, mfpAuthSettings },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(authProviders && { byId: authProviders }),
					...(mfpAuthSettings && { mfpAuthById: mfpAuthSettings }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'auth providers',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	authProvidersReducer,
);

// Selectors
export const getAuthProvidersById = ({ app: { selectedLicenseGroupId }, auth }: RootState) =>
	selectedLicenseGroupId && auth[selectedLicenseGroupId] ? auth[selectedLicenseGroupId].byId : {};
export const getMfpAuthSettings = ({ app: { selectedLicenseGroupId }, auth }: RootState) =>
	selectedLicenseGroupId && auth[selectedLicenseGroupId] ? auth[selectedLicenseGroupId].mfpAuthById : {};

export const getAuthProviders = createSelector([getAuthProvidersById], (authProvidersById) =>
	authProvidersById ? Object.values(authProvidersById) : [],
);
// export const getMfpAuthSettings = createSelector([getMfpAuthSettingsById], (mfpAuthSettingsById) =>
// 	mfpAuthSettingsById ? Object.values(mfpAuthSettingsById) : [],
// );
